var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_35914)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.07 18.08 23 12 23C5.92 23 1 18.07 1 12C1 5.93 5.92 1 12 1C18.08 1 23 5.93 23 12ZM17.21 10.21C17.6 9.82001 17.6 9.19 17.21 8.8C16.82 8.41 16.19 8.41 15.8 8.8L11.01 13.59L9.22 11.8C8.83 11.41 8.2 11.41 7.81 11.8C7.42 12.19 7.42 12.82 7.81 13.21L10.31 15.71C10.5 15.9 10.75 16 11.02 16C11.29 16 11.54 15.9 11.73 15.71L17.23 10.21H17.21Z",
    fill: "#55BB2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_35914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "static/media/icon-check-green.c933c159baa9d79fc86a695cb1bb3639.svg";
export { ForwardRef as ReactComponent };